import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { ArcoVue } from 'y-p-h-in'

import i18n from './locales/index'


createApp(App).use(store).use(router).use(ElementPlus).use(ArcoVue).use(i18n).mount('#app')
